import React from 'react'
import LeftBar from '../../Components/LeftBar'
import Dashnav from '../../Components/Dashnav'
import InvoiceComp from './InvoiceComp'

function Invoices() {
  return (
    <div className='mainContainer'>
        <LeftBar/>
        <div className='theMainContainer'>
            <Dashnav/>
            <InvoiceComp/>      
        </div>
    </div>
  )
}

export default Invoices